import { render } from "./ModalCidades.vue?vue&type=template&id=2ee8db8d&scoped=true"
import script from "./ModalCidades.vue?vue&type=script&lang=js"
export * from "./ModalCidades.vue?vue&type=script&lang=js"

import "./ModalCidades.vue?vue&type=style&index=0&id=2ee8db8d&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee8db8d"]])

export default __exports__